import { FC } from 'react';

const FacebookIcon: FC = () => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.0003 2.66675C8.63633 2.66675 2.66699 8.63608 2.66699 16.0001C2.66699 22.6547 7.54299 28.1707 13.9177 29.1721V19.8534H10.531V16.0001H13.9177V13.0627C13.9177 9.72141 15.907 7.87608 18.9537 7.87608C20.4123 7.87608 21.9377 8.13608 21.9377 8.13608V11.4161H20.2577C18.6003 11.4161 18.0843 12.4441 18.0843 13.4987V16.0001H21.7817L21.191 19.8534H18.0843V29.1721C24.4577 28.1721 29.3337 22.6534 29.3337 16.0001C29.3337 8.63608 23.3643 2.66675 16.0003 2.66675Z"
                fill="#0A163C"
            />
        </svg>
    );
};

export { FacebookIcon };
